<template>
	<b-modal
		id="modal-auto"
		:visible="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		size="lg"
	>
		<b-container
			class="modal-body-content"
			fluid
		>
			<b-row
				class="justify-content-center"
			>
				<b-col>
					<h1
						class="form-heading vehicle"
					>
						Your moving quote is being processed... But one more thing.
					</h1>
				</b-col>
			</b-row>

			<b-row class="auto-form">
				<b-col
					v-if="showAutoInterest"
					class="text-center"
				>
					<h2 class="primary-hd">
						Are you interested in moving a vehicle?
					</h2>
					<h5
						class="sec-hd gray"
					>
						We partner with top-rated national Auto Movers. And, we use the information you’ve already provided.
						Save time. Save money. It’s that easy!
					</h5>
					<div class="row form-row text-center">
						<button
							class="btn btn-primary"
							type="button"
							@click="showAutoForm()"
						>
							Yes
						</button>
						<button
							class="btn"
							type="button"
							@click="next()"
						>
							No
						</button>
					</div>
				</b-col>

				<b-col v-else>
					<b-form
						class="text-left"
						@submit.prevent="onSubmit"
					>
						<h5
							class="sec-hd"
						>
							If you dont know the year, enter the year you purchased the vehicle.
						</h5>
						<h2 class="primary-hd">
							What's your vehicle <b>year</b> ?
						</h2>
						<div class="row">
							<div class="form-input col-md-8">
								<validate-field
									:field-value="year"
									:on-change="onFieldChange"
									:focus="true"
									field="year"
									field-text="year"
									field-ph="e.g. 2018"
								/>
							</div>
						</div>

						<div v-show="validate.year.isValid">
							<h5 class="sec-hd">
								If you can't find exact, select a similar make and model.
							</h5>
							<h2 class="primary-hd">
								What's your vehicle <b>make</b> and <b>model</b> ?
							</h2>
							<div class="row">
								<div class="form-input col-md-6 m-0">
									<div class="input-box">
										<b-dropdown
											id="make"
											ref="ddMake"
											:text="make || 'Select Make'"
											size="lg"
											variant="primary"
										>
											<b-dropdown-item
												v-for="(next_item, index) in makes"
												:key="index"
												:class="{ active: next_item.make === make }"
												@click="onSelectMake(next_item.make)"
											>
												{{ next_item.make }}
											</b-dropdown-item>
										</b-dropdown>
									</div>
								</div>
								<div class="form-input col-md-6 m-0">
									<div class="input-box">
										<b-dropdown
											id="model"
											ref="ddModel"
											:text="model || 'Select Model'"
											size="lg"
											variant="primary"
										>
											<b-dropdown-item
												v-for="(next_item, index) in models"
												:key="index"
												:class="{ active: next_item.model === model }"
												@click="onSelectModel(next_item.model)"
											>
												{{ next_item.model }}
											</b-dropdown-item>
										</b-dropdown>
									</div>
								</div>
							</div>
						</div>
						<div class="form-button text-center">
							<button
								class="btn"
								type="submit"
							>
								<div
									v-if="loading"
									class="loader"
								>
								</div>
								{{ !loading ? 'Submit' : '' }}
							</button>
						</div>
					</b-form>
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
import { mapState } from 'vuex';

import validate from '@/common/validate';

export default {
	name: 'Auto',

	components: {
		'validate-field': validate,
	},

	data() {
		return {
			loading: false,
			showAutoInterest: true,
			makes: [],
			models: [],
			make: 'Select Make',
			model: 'Select Model',
			year: '',
			validateFields: ['make', 'model', 'year'],
		};
	},

	computed: {
		...mapState({
			quote: state => state.quote,
			validator: state => state.validator,
		}),

		hasValidFields() {
			const vm = this;

			return this.$iUtils.every(
				this.validateFields,
				fieldName => vm.validator[fieldName].isValid
			);
		},

		validate() {
			return this.validator;
		},
	},

	watch: {
		validate(to) {
			if (to.model.isValid) {
				this.submitForm();
			}
		},
	},

	created() {
		const quote = this.quote || {};

		this.$analytics.track('autoInterest');

		if (!quote.phone) {
			this.$router.replace({ name: 'Quote-Phone' });
		}
	},

	mounted() {
		const quote = this.quote || {};

		this.year = quote.year || '';
		this.make = quote.make || '';
		this.model = quote.model || '';

		if (quote.year && quote.year.length) {
			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'year',
				isValid: true,
				value: quote.year,
			});

			this.fetchMakes();
		}

		if (this.make.length) {
			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'make',
				isValid: true,
			});

			this.fetchModels();
		}

		if (this.model.length) {
			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'model',
				isValid: true,
			});
		}
	},

	methods: {
		fetchMakes: function() {
			this.makes = [];

			this.$ireloApi
				.get(`service/vehicle/${this.year}`)
				.then(resp => {
					const makes = resp.data || {};

					this.makes = makes.data || [];
				})
				.catch(err => {
					this.$log.error(err);
				});
		},
		fetchModels: function() {
			this.models = [];

			this.$ireloApi
				.get(`service/vehicle/${this.year}/${this.make}`)
				.then(resp => {
					const models = resp.data || {};

					this.models = models.data || [];
				});
		},
		next() {
			if (process.env.VUE_APP_DEBUG !== 'true') {
				const leadToken = this.quote.tokens.move;

				this.$analytics.page(
					'Thank_You',
					{ path: 'Thank_You' },
				);

				this.$session.destroy();

				window.location.href = this.redirect_url
					? this.redirect_url
					: `https://my.topmoving.com/thank-you/${leadToken}`;
			} else {
				this.$router.replace({ name: 'Thank-You' });
			}
		},
		onFieldChange(field, value, isValid) {
			if (field === 'year' && value !== this[field]) {
				this.make = this.model = '';
				this.models = [];

				this.$store.commit('validator/RESET_FIELD', {
					field: 'make',
				});

				this.$store.commit('validator/RESET_FIELD', {
					field: 'model',
				});

				this[field] = value;

				if (isValid) {
					this.fetchMakes();
				}
			}
		},
		showAutoForm() {
			this.showAutoInterest = false;
		},
		submitForm() {
			// Don't try to submit again if one is still in progress
			if (this.loading) {
				return;
			}

			this.loading = true;

			this.$store.dispatch('quote/submitLead', { leadType: 'auto' })
				.then(data => {
					this.$log.info('submitForm -> ', data);
					this.loading = false;

					if (data.status === 'success' || data.status === 200) {
						this.next();
					}
				})
				.catch(errorRes => {
					this.loading = false;

					this.$log.error('submitForm | ', errorRes, this.quote);
					this.$session.destroy();
					window.location.replace(`/secure?source=${this.quote.source}`);
				});
		},
		// EVENTS
		onSelectMake: function(item) {
			this.make = item;
			this.model = '';

			this.$store.dispatch('quote/update', {
				make: this.make,
			});

			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'make',
				isValid: true,
			});

			this.$store.commit('validator/RESET_FIELD', {
				field: 'model',
			});

			this.fetchModels();
		},
		onSelectModel: function(item) {
			this.model = item;
			this.$store.dispatch('quote/update', {
				model: this.model,
			});

			this.$store.commit('validator/SET_VALID_STATE', {
				field: 'model',
				isValid: true,
			});
		},
		onSubmit() {
			if (this.hasValidFields) {
				this.submitForm();
			}
		},
	},
};
</script>

<style lang="scss">
@import "~@/../node_modules/bootstrap/scss/bootstrap-reboot";

#modal-auto {
	padding-right: 0 !important;

	.modal-dialog {
		// top: 50%;
		// transform: translate(0, -50%);
		// Don't try to center modal vertically as the modal will grow
		// and will cause a shift in position
		margin: 0 auto;
		margin-top: 8vh;
		max-width: 360px;
	}

	.modal-header,
	.modal-footer {
		display: none !important;
	}

	.modal-body-content {
		margin: 1rem 0;

		.inline-form {
			margin: 0.5rem 0;
			width: 100%;
		}
	}

	.auto-form {
		margin: auto;
		width: 80%;
	}

	.form-row {
		display: block !important;
		margin: 30px -10px 0 !important;
	}
}

.form-heading {
	color: #e05535;
	font-size: 1.5rem;
	font-weight: 600;
	line-height: 2;
	margin-bottom: 2rem;
	text-align: center;

	span {
		color: #4a4a4a;
	}
}

.form-input,
.form-button {
	margin: 25px 0 0;
}

.sec-hd.gray {
	color: #8a8a8a;
	font-size: 1rem;
}

.inline-form {
	font-size: 1.5rem;
	margin-bottom: 0;

	input.form-control {
		background-color: transparent;
		border: 0;
		width: 88%;

		&:focus {
			background-color: transparent;
			outline: none;
		}

		&::placeholder {
			color: #a7a7a7 !important;
		}
	}

	button {
		cursor: pointer;
		min-height: 50px;
		min-width: 170px;
	}
}

.dropdown {
	text-align: center;
	width: 100%;

	button,
	button:hover {
		background: transparent !important;
		border: 0;
		color: #495057;
		font-size: 1.3rem !important;
		width: 100%;
	}
}

.dropdown-menu {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	color: black;
	display: none;
	margin-top: -1px;
	max-height: 200px;
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0;
	width: 100%;

	&.show {
		.dropdown-toggle {
			color: inherit !important;
		}
	}
}

.dropdown-item {
	border-bottom: 1px solid #f0f0f0 !important;
	cursor: pointer;
	display: block;
	font-size: 1.2rem;
	padding: 10px 15px;
	text-decoration: none;

	&:hover {
		background-color: #3bb671;
		color: white;
	}
}

.dropdown-toggle:after {
	margin-left: 2.3em;
}

@include media-breakpoint-up(sm) {
	#modal-auto  {
		.modal-dialog {
			max-width: 520px;
		}
	}
}

@include media-breakpoint-up(md) {
	#modal-auto  {
		.modal-dialog {
			max-width: 710px;
		}
	}
}

@include media-breakpoint-up(lg) {
	#modal-auto {
		.modal-dialog {
			max-width: 840px;
		}
	}
}
</style>
